import { callApi } from './service'

export const couponService = {
	getAll
}

async function getAll() {
	return callApi('/backend/Coupon/CouponCarrousel', 'GET')
		.then((result) => {
			if(result.responseCode = "00"){
            return result.data;
        }
        else{
            return{};
        }
		});
}